export const PRE_MANAGE_USER = "users/PRE_MANAGE_USER";

export default function preManageUserAction(user) {
  return {
    "payload": {user},
    "type": PRE_MANAGE_USER
  };
}
